import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";

import {ref} from "vue";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";

export const useUserStore = defineStore(
    'userStore',
    () => {

        //const latestAccessTime = ref(null);
        const selectedRowBranchId = ref(null);
        const selectedRowRoleId = ref(null);
        const selectedPassword = ref("");

        const setSelectedRowBranchId = (branch_id) => {
            selectedRowBranchId.value = branch_id;
        }

        const setSelectedRowRoleId = (role_id) => {
            selectedRowRoleId.value = role_id;
        }

        const setSelectedPassword = (password) => {
            selectedPassword.value = password;
        }

        const listUserCustomStore = new CustomStore({
            key: "id",
            byKey: async (key) => {
                try {
                    const response = await axios.get(`${API_BASE_URL}/users/${key}`, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });

                    if (response.data) {
                        return response.data; // Assuming the backend returns the user object directly
                    }
                } catch (error) {
                    console.error('Error fetching user by key:', error);
                    throw error;
                }
            },
            load: async (loadOptions) => {
                let params = {};
                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }
                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }
                const response = await axios.get(`${API_BASE_URL}/users`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }
                throw 'Data loading error';
            },
            update: async (key, values) => {
                const updateUrl = `${API_BASE_URL}/users/${key}`;

                if(selectedPassword.value !== null || selectedPassword.value !== ""){
                    values.password = selectedPassword.value;
                }


                try {
                    const response = await axios.put(updateUrl, values, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        return response.data.data;
                    }
                } catch (error) {
                    console.error('Update error:', error);
                    throw error;
                }
            },
            insert: async (values) => {
                const insertUrl = `${API_BASE_URL}/users`;

                values.role_id = selectedRowRoleId.value;
                values.branch_id = selectedRowBranchId.value;
                values.password = selectedPassword.value;


                try {
                    const response = await axios.post(insertUrl, values, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        return response.data.data;
                    }
                } catch (error) {
                    console.error('Insert error:', error);
                    throw error;
                }
            },
            remove: async (key) => {
                const deleteUrl = `${API_BASE_URL}/users/${key}`;
                try {
                    const response = await axios.delete(deleteUrl, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        return key; // Return the key of the deleted item
                    }
                } catch (error) {
                    console.error('Delete error:', error);
                    throw error;
                }
            },
        });
        const listBranchesCustomStore = new CustomStore({
            key: "id",
            byKey: async (key) => {
                try {
                    const response = await axios.get(`${API_BASE_URL}/branches/${key}`, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });

                    if (response.data) {
                        return response.data; // Assuming the backend returns the user object directly
                    }
                } catch (error) {
                    console.error('Error fetching user by key:', error);
                    throw error;
                }
            },
            load: async (loadOptions) => {
                let params = {};
                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }
                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }
                const response = await axios.get(`${API_BASE_URL}/branches`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                })

                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }
                throw 'Data loading error';
            },
        });
        const listRolesCustomStore = new CustomStore({
            key: "id",
            byKey: async (key) => {
                try {
                    const response = await axios.get(`${API_BASE_URL}/roles/${key}`, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });

                    if (response.data) {
                        return response.data; // Assuming the backend returns the user object directly
                    }
                } catch (error) {
                    console.error('Error fetching user by key:', error);
                    throw error;
                }
            },
            load: async (loadOptions) => {
                let params = {};
                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }
                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }
                const response = await axios.get(`${API_BASE_URL}/roles`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }
                throw 'Data loading error';
            },
        });

        const fetchBranches = async () => {
            const response = await axios.get(`${API_BASE_URL}/branches`, {
                headers: {
                    Authorization: api.defaults.headers.common['Authorization'],
                    'Content-Type': 'application/json',
                },
            })

            if (response.data) {
                return response.data;
            }

            return [];
        };

        const fetchRoles = async () => {
            const response = await axios.get(`${API_BASE_URL}/roles`, {

                headers: {
                    Authorization: api.defaults.headers.common['Authorization'],
                    'Content-Type': 'application/json',
                },
            });

            if (response.data) {
                return response.data
            }
            return [];
        };

        return {
            listUserCustomStore,
            listBranchesCustomStore,
            listRolesCustomStore,
            selectedRowBranchId,
            selectedRowRoleId,
            selectedPassword,
            setSelectedRowRoleId,
            setSelectedRowBranchId,
            setSelectedPassword,fetchRoles,fetchBranches
        }
    });